var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#A1C7FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#A1C7FA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 58,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#A1C7FA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 29,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#A1C7FA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 29,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#A1C7FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundTable);
export default __webpack_public_path__ + "static/media/roundTable.ce20e60656f0c7c843862d2b0bc9a1be.svg";
export { ForwardRef as ReactComponent };